<template>
    <div>
        <p class="moow-info-txt">Keep track of private files about this deal</p>

        <md-progress-spinner
                v-if="uploadingFiles"
                :md-diameter="30"
                :md-stroke="3"
                md-mode="indeterminate"
        ></md-progress-spinner>
        <md-button
                v-else
                class="md-primary play-cta-button-flat mb-3"
                @click="showFileUploader = true"
                :disabled="uploadingFiles"
        >Upload files</md-button>

        <div
                v-if="noFiles"
                class="no-content-holder"
                :style="{ 'background': 'url(' + noContentIcon + ') no-repeat center center /contain'}"
        ></div>
        <div v-else class="files-container play-shadow">
            <div class="files-scroll-container">
                <div v-for="(filename, index) in listingFileNames" :key="filename+index">
                    <md-chip
                            class="md-primary mt-3 play-chip light"
                            @click="fileAction(filename)"
                            md-clickable
                    >
                        <md-icon>{{getFileIconGate(filename)}}</md-icon>
                        {{filename}}
                    </md-chip>
                </div>
                <div class="scroll-opaq-compensator" />
            </div>
        </div>
        <md-dialog :md-active.sync="showFileUploader" style="width:90vw;">
            <b-row style="padding:1em;">
                <b-col>
                    <multi-file-uploader v-if="showFileUploader" @uploadedFileNames="addFiles"></multi-file-uploader>
                </b-col>
            </b-row>
        </md-dialog>

        <md-snackbar :md-duration="Infinity" md-persistent :md-active.sync="showDownloadSnackbar">
            <span>{{downloadSnackBarMessage}}</span>
            <md-progress-spinner
                    v-if="downloadingFile"
                    :md-diameter="30"
                    :md-stroke="3"
                    md-mode="indeterminate"
            ></md-progress-spinner>
            <div v-else>
                <md-button class="md-primary" @click="showDownloadSnackbar = false">Cancel</md-button>
                <md-button class="md-accent" @click="deleteFile()">Delete</md-button>
                <md-button class="md-raised md-primary" @click="downloadFile()">Download</md-button>
            </div>
        </md-snackbar>

        <md-snackbar md-persistent :md-active.sync="showSnackbar">
            <span>{{snackbarMessage}}</span>
        </md-snackbar>
    </div>
</template>

<script>
    import { downloadUserFile, getFileIcon } from "../platform/files/services/fileService";
    import MultiFileUploader from "../components/files/multiFileUploader.vue";

    export default {
        name: "ListingDealFiles",
        components: { MultiFileUploader },
        props: {
            accountId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                uploadingFiles: false,
                showFileUploader: false,
                showDownloadSnackbar: false,
                downloadingFile: false,
                showSnackbar: false,
                downloadSnackBarMessage: '',
                selectedFileName: '',
                snackbarMessage: '',
            }
        },
        computed: {
            listingFileNames() {
                const { documentDet: { ownerFileNames: result = [] } = {} } = this.$store.getters.dealInView;

                return result;
            },
            noFiles() {
                return !this.listingFileNames.length;
            },
            noContentIcon() {
                return require("../assets/404_listing.svg");
            },
            selectedFileNameShort() {
                let sub = this.selectedFileName.substring(0, 16);
                return sub + "...";
            },
        },
        methods: {
            getFileIconGate(filename) {
                return getFileIcon(filename);
            },
            fileAction(filename) {
                this.selectedFileName = filename;
                this.downloadSnackBarMessage = this.selectedFileNameShort;
                this.showDownloadSnackbar = true;
            },
            async addFiles(fileNames) {
                try {
                    this.showFileUploader = false;
                    this.uploadingFiles = true;

                    await this.$store.dispatch('ADD_DEAL_DOCUMENTS', {
                        accountId: this.accountId,
                        documents: fileNames
                    });
                    this.uploadingFiles = false;
                }
                catch (error) {
                    console.error(error);
                }
            },
            async deleteFile() {
                try {
                    if (!this.selectedFileName) {
                        return;
                    }
                    this.showDownloadSnackbar = true;
                    this.downloadSnackBarMessage = "Deleting file...";

                    await this.$store.dispatch('DELETE_DEAL_DOCUMENT', {
                        accountId: this.accountId,
                        fileName: this.selectedFileName,
                    });
                    this.showDownloadSnackbar = false;
                    this.uploadingFiles = false;
                }
                catch (error) {
                    console.error(error);
                }
            },
            downloadFile() {
                this.downloadSnackBarMessage = "Preparing to download";
                this.downloadingFile = true;
                downloadUserFile(this.selectedFileName)
                    .catch(err => {
                        this.notifyUser(err);
                    })
                    .finally(f => {
                        this.downloadingFile = false;
                        this.showDownloadSnackbar = false;
                    });
            },
            notifyUser(msg) {
                this.snackbarMessage = msg;
                this.showSnackbar = true;
            },
        },
    }
</script>

<style scoped>
    @import "../assets/styles/listing-manager.css";
    @import "../assets/styles/global.css";

    .scroll-opaq-compensator {
        height: 30px;
        widows: 100%;
    }

    .files-scroll-container {
        height: 100%;
        margin: 0;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .files-scroll-container::-webkit-scrollbar {
        width: 0px;
    }

    .files-container {
        position: relative;
        height: 400px;
        padding: 1em;
        background-color: white;
        overflow: hidden;
        border-radius: 10px;
    }

    .files-container:after {
        content: "";
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 0;
        pointer-events: none;
        background-image: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 1) 90%
        );
        width: 100%;
        height: 5em;
    }

    .listing-hero-container {
        height: 20vh;
        position: relative;
    }

    .listing-hero-overscreen {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        background-color: #020202ad;
        color: white;
        text-align: center;
        padding-top: 4em;
    }

    .listing-hero-holder {
        position: absolute;
        height: 100%;
        width: 100%;
    }

    .analytics-view-loader-mini img {
        height: 38px;
        width: 38px;
    }

    .no-content-holder {
        height: 100px;
        background-size: contain;
    }
</style>


// WEBPACK FOOTER //
// src/components/listingDealFiles.vue